module.exports = __webpack_public_path__ + "static/media/sc.30759b7a.svg";